import { Modal } from '@salecycle/ui-component-library';
import {
  usePreferencesDispatch,
  toggleSelectClientModal,
  hideSelectClientModalAndShowSearchOverlay,
  usePreferencesState,
} from 'core/preferences/usePreferencesContext';
import { useTranslation } from 'react-i18next';

export function SelectClientModal() {
  const { selectClientModalVisible } = usePreferencesState();
  const { t } = useTranslation('components');
  const dispatch = usePreferencesDispatch();

  return (
    <Modal
      heading={t('selectClientModal.heading')}
      size="large"
      variation="clean"
      isOpen={selectClientModalVisible}
      onCloseButtonClicked={() => toggleSelectClientModal(dispatch, false)}
      onCancelButtonClicked={() => toggleSelectClientModal(dispatch, false)}
      onOkButtonClicked={() => hideSelectClientModalAndShowSearchOverlay(dispatch)}
      okButtonLabel="Select a client"
    >
      <p>{t('selectClientModal.description')}</p>
    </Modal>
  );
}
